import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { WxButton } from '../..';
import {
  sortings,
  useFiltersContext,
} from '../../../hooks/context/useFiltersContext';
import { breakpoint } from '../../../styles/constants';
import { formatRange } from '../../../utils/formatRange';

interface Props {
  desktop?: boolean;
}

export const FilterCards = React.memo(({ desktop = false }: Props) => {
  const {
    onlyAvailable,
    attributes,
    range,
    toggleAttribute,
    toggleRange,
    sorting,
    setSorting,
    saveFilters,
    resetFilters,
  } = useFiltersContext();
  const [save, setSave] = useState<boolean>(false);

  const sortingSelected = sortings.find((sort) => sort.value === sorting);

  const emptyFilterCards =
    onlyAvailable === false &&
    attributes.length === 0 &&
    sortingSelected === undefined &&
    range === undefined;

  useEffect(() => {
    if (save) {
      saveFilters();
      setSave(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [save]);

  const icon = <FontAwesomeIcon icon={faTimes} size={'xs'} />;
  if (emptyFilterCards) return null;
  return (
    <Wrapper>
      <DivFilterCards desktop={desktop} empty={emptyFilterCards}>
        {range && (
          <div
            onClick={() => {
              toggleRange(range);
              desktop && setSave(true);
            }}
          >
            <p>{formatRange(range)}</p>
            {icon}
          </div>
        )}
        {sortingSelected && (
          <div
            key={`selected-sorting`}
            onClick={() => {
              setSorting(undefined);
              desktop && setSave(true);
            }}
          >
            <p>{sortingSelected.key}</p>
            {icon}
          </div>
        )}
        {attributes.map((attr) => (
          <div
            key={`selected-attre${attr.id}`}
            onClick={() => {
              toggleAttribute(attr);
              desktop && setSave(true);
            }}
          >
            <p>{attr.label ?? attr.identifier ?? attr.code}</p>
            {icon}
          </div>
        ))}
      </DivFilterCards>
      {(sorting !== 'RECOM' ||
        attributes.length > 0 ||
        range?.max ||
        range?.min ||
        onlyAvailable) && (
        <Button>
          <WxButton
            onClick={() => resetFilters()}
            label={'EFFACER LES FILTRES'}
            type={'neutral'}
            darkMode
            noArrow
          />
        </Button>
      )}
    </Wrapper>
  );
});

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.div`
  display: none;
  @media (min-width: ${breakpoint}) {
    display: block;
    margin-top: 1.25rem;
  }
`;

const DivFilterCards = styled.div<{ desktop: boolean; empty: boolean }>`
  flex-wrap: wrap;
  gap: 0.625rem;
  margin-bottom: ${({ desktop, empty }) =>
    desktop || empty ? 'unset' : '1.25rem'};
  display: ${({ desktop }) => (desktop ? 'none' : 'flex')};
  @media (min-width: ${breakpoint}) {
    display: flex;
    margin-top: 1.25rem;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: 300;
    font-size: 0.75rem;
    @media (min-width: ${breakpoint}) {
      font-size: 0.875rem;
    }
  }

  > div {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    padding: 0.525rem;
    background-color: ${({ theme, desktop }) =>
      desktop ? theme.colors.white : theme.colors.lightgray};
  }
`;
